import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import i18n from '@/plugins/i18n';
import App from '@/components/App';
import '@/plugins';
import '@/components';

require('@/utils/echo');

Vue.config.productionTip = false;

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.csrf_token = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

new Vue({
  i18n,
  store,
  router,
  ...App
});
